<template>
    <div class="financeApplication__form__input financeApplication__form__input--text">
        <input :type="type"
               :name="name"
               :value="value"
               :id="id"
               :disabled="disabled"
               :placeholder="placeholder"
               :max="max"
               @input="$emit('input', $event.target.value)"
               @change="$emit('change', $event.target.value)"
               @blur="$emit('blur')"
        />
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
        },
        value: {
            type: [String, Number],
        },
        id: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
        },
        type: {
            type: String,
            default: 'text'
        },
        max: {
            type: Number
        }
    },
}
</script>